import React from "react";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";

import titleize from "underscore.string/titleize";
import Moment from "react-moment";
import Author from "./author";

const Article = ({ article }) => (
  <article className="blog-post" itemScope itemType="http://schema.org/Article">
    <header>
      <h1 itemProp="headline">{titleize(article.title)}</h1>
      <p>
        <Moment date={article.createdAt} format={"MMM DD, YYYY"} />
      </p>
      {article?.author?.firstName &&
        article?.author?.lastName &&
        article?.author?.image && (
          <p>
            <Author
              firstName={article.author.firstName}
              lastName={article.author.lastName}
              image={article.author.image}
            />
          </p>
        )}
    </header>

    <section itemProp="articleBody" className="ck-content">
      {ReactHtmlParser(article.data)}
    </section>
  </article>
);

const ArticleDisplay = ({ article }) => {
  if (article) return <Article article={article} />;
  else return <>Not Found</>;
};

export default ArticleDisplay;
